import React from 'react';
import '../styles/Hero.css';

function Hero() {
    return (
        <section className= "hero">
            <div className="hero-tag"> Calgary's Premier Esthetician </div>

            <h1>
                Glow up with<br />
                <span>Brilliant Beauty</span>
            </h1>

            <p>
                Luxury skincare and beauty treatments tailored to bring out your natural radiance. 
                Feel confident, beautiful, and refreshed.
            </p>

            <div className="hero-buttons">
                <a href='#booking'>
                    <button className ="btn-primary"> Book Appointment</button>
                </a>
                <a href='#services'>
                    <button className ="btn-secondary"> View Services</button>
                </a>
            </div>
        </section>
    );
}

export default Hero;